export default __webpack_public_path__ + "static/media/latestadd_icon.5ff6e50c.svg";